import jsPDF from "jspdf";

/**
 * Download a table-like dataset to a PDF file (A4 portrait).
 * columns: [{key, label, num?}]
 * rows: array of objects
 */
export function tableToPdf({ title, subtitle, columns, rows, filename = "export.pdf", totals = null, footer = "AccountifyPro · Developed by ANV ASSOCIATE · 8446463026" }) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  let y = 40;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9); doc.setTextColor("#666");
  doc.text("ANV ASSOCIATE · AccountifyPro", 40, y);
  y += 4;
  doc.setFontSize(16); doc.setTextColor("#111");
  doc.text(title || "Report", 40, y + 14);
  y += 18;
  if (subtitle) {
    doc.setFontSize(9); doc.setFont("helvetica", "normal"); doc.setTextColor("#555");
    doc.text(subtitle, 40, y + 12); y += 12;
  }
  y += 12;
  doc.setDrawColor(180); doc.line(40, y, W - 40, y); y += 10;

  const cols = columns.map((c) => ({ ...c, w: c.w || (c.num ? 70 : 90) }));
  const colXs = [];
  let x = 40;
  for (const c of cols) { colXs.push(x); x += c.w; }
  const rowH = 14;

  const header = () => {
    doc.setFont("helvetica", "bold"); doc.setFontSize(8);
    doc.setFillColor(240); doc.rect(40, y, W - 80, rowH, "F");
    cols.forEach((c, i) => {
      doc.text(String(c.label), c.num ? colXs[i] + c.w - 6 : colXs[i] + 4, y + 10, { align: c.num ? "right" : "left" });
    });
    y += rowH + 2;
    doc.setFont("helvetica", "normal");
  };
  header();

  doc.setFontSize(8); doc.setTextColor("#111");
  for (const r of rows) {
    if (y > H - 60) { doc.addPage(); y = 40; header(); }
    cols.forEach((c, i) => {
      let v = r[c.key];
      if (v === null || v === undefined) v = "";
      if (c.num && typeof v === "number") v = v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const txt = String(v).slice(0, c.num ? 20 : Math.floor(c.w / 5));
      doc.text(txt, c.num ? colXs[i] + c.w - 6 : colXs[i] + 4, y + 10, { align: c.num ? "right" : "left" });
    });
    y += rowH;
  }
  if (totals) {
    y += 4;
    doc.setDrawColor(120); doc.line(40, y, W - 40, y); y += 12;
    doc.setFont("helvetica", "bold");
    cols.forEach((c, i) => {
      const v = totals[c.key];
      if (v === undefined) return;
      const txt = typeof v === "number" ? v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : String(v);
      doc.text(txt, c.num ? colXs[i] + c.w - 6 : colXs[i] + 4, y + 10, { align: c.num ? "right" : "left" });
    });
  }

  doc.setFontSize(8); doc.setTextColor("#888");
  doc.text(footer, W / 2, H - 24, { align: "center" });
  doc.save(filename);
}

/**
 * Free WhatsApp send — opens wa.me with pre-filled body. Zero cost.
 * Cleans phone to digits only, prepends 91 if it looks like a local Indian 10-digit number.
 */
export function whatsappSend(phone, body) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) {
    alert("No phone number available for this contact.");
    return;
  }
  const withCC = digits.length === 10 ? "91" + digits : digits;
  const url = `https://wa.me/${withCC}?text=${encodeURIComponent(body)}`;
  window.open(url, "_blank", "noopener");
}
